// export const API_BASE_URL = 'http://192.168.92.146:5050/api/v1/';
// export const API_BASE_URL = process.env.REACT_APP_API_URL;
// export const API_BASE_URL = 'http://192.168.1.7:5050/api/v1/';
export const API_BASE_URL = process.env.REACT_APP_API_URL;

// export const API_BASE_URL = 'https://api-sellitrader.webdadsprojects.com/';
